import { type Route } from '@angular/router';
import { authGuard } from './shared/auth.guard';

export const appRoutes: Route[] = [
  {
    // 인증 후 영역 — 셸은 app.ts(앱 루트)에 있다(2026-08-11 루트 배치 마이그레이션).
    // 이 앱엔 로그인 화면이 없어(auth.guard.ts 참고) authGuard를 이 pathless 그룹에
    // 걸어 미로그인이면 children이 렌더되기 전에 schoolbell-e-web으로 리다이렉트한다
    // (2026-08-05 developer-web-domain-separation 플랜).
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'apps',
      },
      {
        // App(1):OAuthClient(N) 그룹화 — 목록 단위는 App(2026-07-07-oauth-client-app-grouping.md).
        path: 'apps',
        loadComponent: () =>
          import('./features/oauth-clients/list/oauth-client-list.component').then(
            (m) => m.OAuthAppListComponent,
          ),
      },
      {
        path: 'apps/new',
        loadComponent: () =>
          import('./features/oauth-clients/new/oauth-client-new.component').then(
            (m) => m.OAuthAppNewComponent,
          ),
      },
      {
        path: 'apps/:appId',
        loadComponent: () =>
          import('./features/oauth-clients/app-detail/oauth-app-detail.component').then(
            (m) => m.OAuthAppDetailComponent,
          ),
      },
      {
        path: 'apps/:appId/oauth-clients/new',
        loadComponent: () =>
          import(
            './features/oauth-clients/client-new/oauth-client-new-under-app.component'
          ).then((m) => m.OAuthClientNewUnderAppComponent),
      },
      {
        path: 'apps/:appId/oauth-clients/:clientId',
        loadComponent: () =>
          import('./features/oauth-clients/detail/oauth-client-detail.component').then(
            (m) => m.OAuthClientDetailComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
